import { Checkbox } from '@repo/ui/src/components/Form';
import Markdown from '@repo/ui/src/components/Markdown';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  title?: string;
  description?: string;
  label: string;
  disclaimer?: string;
  name: string;
  disabled: boolean;
}
const PreferenceCheckbox = ({ title, description, label, disclaimer, name, disabled }: Props) => {
  return (
    <div>
      <h6 className="tra-text-web-heading-7 pb-4 ">{title}</h6>
      {description && <p className="tra-text-web-body-m pb-5">{description}</p>}
      <hr className="border w-full border-warm-400" />
      <div className="pt-3">
        <Checkbox
          label={label}
          id="emailPreferences"
          name={name}
          testId="test"
          disabled={disabled}
          labelStyle="tra-text-web-body-m"
        />
        {disclaimer && (
          <Markdown className={classNames('mt-3 tra-text-web-body-s')}>{disclaimer}</Markdown>
        )}
      </div>
    </div>
  );
};

export default PreferenceCheckbox;
